export const getDefaultSizeConversion = country => {
  switch (country) {
    case 'US':
    case 'CA':
    case 'AU':
    case 'NZ':
    case 'HK':
    case 'RU':
    case 'CN':
    case 'TR':
    case 'IL':
    case 'QA':
    case 'NG':
    case 'EG':
    case 'MA':
    case 'ZA':
    case 'SA':
    case 'TW':
      return 'US';
    case 'JP':
    case 'MX':
      return 'CM';
    case 'KR':
      return 'MM';
    case 'GB':
    case 'IE':
      return 'UK';
    case 'ES':
    case 'DE':
    case 'FR':
    case 'BE':
    case 'IT':
    case 'SE':
    case 'CZ':
    case 'GR':
    case 'HR':
    case 'AT':
    case 'NO':
    case 'HU':
    case 'PL':
    case 'PT':
    case 'NL':
    case 'SK':
    case 'CH':
    case 'LU':
    case 'SI':
    case 'DK':
    case 'FI':
      return 'EU';
    default:
      return 'US';
  }
};

export const SIZE_CONVERSION_OPTIONS = [
  { label: 'CM', value: 'CM' },
  { label: 'EU', value: 'EU' },
  { label: 'MM', value: 'MM' },
  { label: 'UK', value: 'UK' },
  { label: 'US', value: 'US' }
];
